import { render, staticRenderFns } from "./PerformanceStatsGraph.vue?vue&type=template&id=2313284b&scoped=true"
import script from "./PerformanceStatsGraph.vue?vue&type=script&lang=js"
export * from "./PerformanceStatsGraph.vue?vue&type=script&lang=js"
import style0 from "./PerformanceStatsGraph.vue?vue&type=style&index=0&id=2313284b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2313284b",
  null
  
)

export default component.exports